(function () {
  'use strict';

  var DESKTOP = '(min-width: 64em)';
  var TRIGGER = '[data-country-modal-open]';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function normalize(value) {
    var text = String(value || '').toLowerCase();

    if (text.normalize) {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return text;
  }

  function CountryModal(root) {
    this.root = root;
    this.dialog = root.querySelector('.country-modal__dialog');
    this.form = root.querySelector('form');
    this.input = root.querySelector('[data-country-modal-input]');
    this.search = root.querySelector('[data-country-modal-search]');
    this.list = root.querySelector('[data-country-modal-list]');
    this.results = root.querySelector('[data-country-modal-results]');
    this.empty = root.querySelector('[data-country-modal-empty]');
    this.status = root.querySelector('[data-country-modal-status]');

    this.options = Array.prototype.slice.call(root.querySelectorAll('[data-country-modal-option]'));
    this.visible = this.options.slice();
    this.active = null;
    this.opener = null;
    this.open = false;
    this.submitting = false;

    this.options.forEach(function (option) {
      var name = option.querySelector('.country-modal__name');
      var meta = option.querySelector('.country-modal__meta');

      option.haystack = normalize([
        name ? name.textContent : '',
        meta ? meta.textContent : '',
        option.getAttribute('data-value')
      ].join(' '));
    });

    this.onKeydown = this.handleKeydown.bind(this);
    this.onSearch = this.filter.bind(this);
    this.onListClick = this.handleListClick.bind(this);
    this.onDismiss = this.handleDismiss.bind(this);
    this.onScroll = this.syncFade.bind(this);

    this.search.addEventListener('input', this.onSearch);
    this.list.addEventListener('click', this.onListClick);
    this.root.addEventListener('keydown', this.onKeydown);
    this.results.addEventListener('scroll', this.onScroll);

    Array.prototype.forEach.call(root.querySelectorAll('[data-country-modal-dismiss]'), function (node) {
      node.addEventListener('click', this.onDismiss);
    }, this);
  }

  CountryModal.prototype.template = function (name, token, value) {
    var raw = this.root.getAttribute(name) || '';
    return raw.replace(token, value);
  };

  CountryModal.prototype.show = function (opener) {
    if (this.open) return;

    this.opener = opener || null;
    this.open = true;

    document.documentElement.classList.add('country-modal-locked');

    this.root.removeAttribute('hidden');

    // Force layout so the entry transition runs from the hidden state.
    this.root.offsetHeight;
    this.root.classList.add('is-open');

    this.search.value = '';
    this.filter();
    this.search.focus();

    var current = this.list.querySelector('.country-modal__item--current');
    if (current) this.results.scrollTop = Math.max(0, current.offsetTop - this.results.clientHeight / 2);

    this.syncFade();
  };

  CountryModal.prototype.hide = function () {
    if (!this.open) return;

    this.open = false;
    this.root.classList.remove('is-open');
    this.setActive(null);

    document.documentElement.classList.remove('country-modal-locked');

    var root = this.root;
    var opener = this.opener;
    this.opener = null;

    window.setTimeout(function () {
      if (!root.classList.contains('is-open')) root.setAttribute('hidden', '');
    }, 240);

    if (opener && document.contains(opener)) opener.focus();
  };

  CountryModal.prototype.filter = function () {
    var terms = normalize(this.search.value).trim();

    this.visible = this.options.filter(function (option) {
      var match = !terms || option.haystack.indexOf(terms) !== -1;

      if (match) {
        option.removeAttribute('hidden');
      } else {
        option.setAttribute('hidden', '');
      }

      return match;
    });

    this.results.scrollTop = 0;
    this.setActive(null);

    if (this.visible.length) {
      this.empty.setAttribute('hidden', '');
    } else {
      this.empty.textContent = this.template('data-empty-template', '__terms__', this.search.value.trim());
      this.empty.removeAttribute('hidden');
    }

    this.announce();
    this.syncFade();
  };

  CountryModal.prototype.syncFade = function () {
    var pane = this.results;
    var overflows = pane.scrollHeight > pane.clientHeight + 4;
    var atEnd = pane.scrollHeight - pane.scrollTop - pane.clientHeight < 4;

    pane.classList.toggle('is-fading', overflows && !atEnd);
  };

  CountryModal.prototype.announce = function () {
    var count = this.visible.length;

    this.status.textContent = count === 1
      ? this.root.getAttribute('data-count-one') || '1'
      : this.template('data-count-template', '__count__', count);
  };

  CountryModal.prototype.setActive = function (option) {
    if (this.active) this.active.classList.remove('is-active');

    this.active = option || null;

    if (!this.active) {
      this.search.removeAttribute('aria-activedescendant');
      return;
    }

    this.active.classList.add('is-active');
    this.search.setAttribute('aria-activedescendant', this.active.id);

    var top = this.active.offsetTop;
    var bottom = top + this.active.offsetHeight;

    if (top < this.results.scrollTop) {
      this.results.scrollTop = top - 8;
    } else if (bottom > this.results.scrollTop + this.results.clientHeight) {
      this.results.scrollTop = bottom - this.results.clientHeight + 8;
    }
  };

  CountryModal.prototype.step = function (delta) {
    if (!this.visible.length) return;

    var index = this.active ? this.visible.indexOf(this.active) : -1;
    var next = index + delta;

    if (next < 0) next = this.visible.length - 1;
    if (next > this.visible.length - 1) next = 0;

    this.setActive(this.visible[next]);
  };

  CountryModal.prototype.select = function (option) {
    if (!option || this.submitting) return;

    this.submitting = true;
    this.input.value = option.getAttribute('data-value');
    this.form.submit();
  };

  CountryModal.prototype.handleListClick = function (event) {
    var option = event.target.closest('[data-country-modal-option]');
    if (option) this.select(option);
  };

  CountryModal.prototype.handleDismiss = function (event) {
    event.preventDefault();
    this.hide();
  };

  CountryModal.prototype.handleKeydown = function (event) {
    switch (event.key) {
      case 'Escape':
        event.preventDefault();
        this.hide();
        break;
      case 'ArrowDown':
        event.preventDefault();
        this.step(1);
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.step(-1);
        break;
      case 'Enter':
        event.preventDefault();
        this.select(this.active || (this.visible.length === 1 ? this.visible[0] : null));
        break;
      case 'Tab':
        this.trapFocus(event);
        break;
      default:
        break;
    }
  };

  CountryModal.prototype.trapFocus = function (event) {
    var nodes = Array.prototype.filter.call(
      this.dialog.querySelectorAll(FOCUSABLE),
      function (node) { return node.offsetParent !== null; }
    );

    if (!nodes.length) return;

    var first = nodes[0];
    var last = nodes[nodes.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  CountryModal.prototype.unload = function () {
    this.hide();
    this.search.removeEventListener('input', this.onSearch);
    this.list.removeEventListener('click', this.onListClick);
    this.root.removeEventListener('keydown', this.onKeydown);
    this.results.removeEventListener('scroll', this.onScroll);
  };

  var instance = null;
  var desktop = window.matchMedia(DESKTOP);

  function mount() {
    var root = document.querySelector('[data-country-modal]');

    if (instance && instance.root === root) return;
    if (instance) instance.unload();

    instance = root ? new CountryModal(root) : null;
    document.documentElement.classList.toggle('country-modal-ready', Boolean(instance));
  }

  // Capture phase on the document so the trigger's own disclosure handler,
  // registered by <localization-form>, never sees the click on desktop.
  document.addEventListener('click', function (event) {
    if (!instance || !desktop.matches) return;
    if (!event.target || !event.target.closest) return;

    var trigger = event.target.closest(TRIGGER);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    instance.show(trigger);
  }, true);

  // Selecting a country latches `submitting` so a double click cannot fire two
  // navigations. Back-navigating restores that latched state from the bfcache,
  // so clear it whenever the page is shown again.
  window.addEventListener('pageshow', function () {
    if (instance) instance.submitting = false;
  });

  function onBreakpoint(event) {
    if (!event.matches && instance) instance.hide();
  }

  if (desktop.addEventListener) {
    desktop.addEventListener('change', onBreakpoint);
  } else if (desktop.addListener) {
    desktop.addListener(onBreakpoint);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', mount);
})();
